module.exports = {
	"site.title": "The Bible in Its Traditions",
	"Old Testament": "Old Testament",
	"New Testament": "New Testament",
	"footer": {
		"project.of": "A project of the Bible in Its Traditions Research Program AISBL",
		"ebaf.link": "Directed by the <a href=\"http://www.ebaf.edu/\">École Biblique et Archéologique</a> in Jerusalem",
		"donation.link": "To support us, <a href=\"https://scroll.bibletraditions.org/register\">click here</a>",
		"copyright": "© 2008–2023 BEST AISBL | École Biblique. All rights reserved. Patent pending."
	},
	"frontdoor": {
		"about.h": "What this website is about",
		"about": "The Bible in Its Traditions is a project of the École Biblique et Archéologique Française de Jérusalem, the creators of the Jerusalem Bible.",
		"goal.h": "The goal of this project",
		"goal": "We intend to create the most extensive and helpful set of notes for the entire bible, with information of interest both to biblical scholars and casual readers.",
		"features.h": "Unique Features",
		"features": "The Bible in Its Traditions will present significant differences between different versions of the text of the Bible in the text itself, rather than in footnotes. In addition, the text is accompanied by extensive notes divided into different topics, such as vocabulary, social and cultural milieu, and Jewish and Christian tradition, among others.",
		"sample": "View this sample passage",
		"demonstration.volume": "See our demonstration volume",
		"visit.the.blog": "Follow us in real time",
		"visit.the.scroll": "Use the consultation interface",
		"contrib.h": "For potential contributors",
		"contrib": "We are actively seeking scholarly contributions to our project. If you would like to create a sample translation and set of notes for consideration by our editors, please contact us.",
		"lagrange": "Fr. M.-J. Lagrange, founder of the École Biblique"
	},
	"legal.terms": "Legal Terms",
	"browser.too.old": "This site will not function correctly in your current browser. In order to use the site, please upgrade to Internet Explorer 11 or Edge, or download Chrome, Firefox, Opera, or Safari.",
	"content.type": {
		"biblio.ref": "bibliographic reference",
		"Biblio.Ref": "Bibliographic Reference",
		"biblio.refs": "bibliographic references",
		"Biblio.Refs": "Bibliographic References",
		"marg.ref": "marginal reference",
		"Marg.Ref": "Marginal Reference",
		"marg.refs": "marginal references",
		"Marg.Refs": "Marginal References",
		"note": "note",
		"Note": "Note",
		"notes": "notes",
		"Notes": "Notes",
		"synth.note": "synthetic note",
		"Synth.Note": "Synthetic Note",
		"synth.notes": "synthetic notes",
		"Synth.Notes": "Synthetic Notes",
		"verse": "verse",
		"Verse": "Verse",
		"verses": "verses",
		"Verses": "Verses"
	},
	"bibliography": "bibliography",
	"@Demonstration_Volume@": "The Demonstration Volume",
	"bible.passage": {
		"label.noscript": "Go to a biblical passage:",
		"goto": "Go to %s",
		"search": "Search for “%s”"
	},
	"PDF": "PDF",
	"ODT": "ODT (LibreOffice/OpenOffice)",
	"@View_as@": "View as",
	"@New...@": "New...",
	"@edit_marg_ref@": "Edit Reference",
	"@new_marg_ref@": "Marginal Reference",
	"@new_bib_ref@": "Bibliographic Reference",
	"@edit_note@": "Edit Note",
	"@edit_reference@": "Edit Reference",
	"@new_note@": "Note",
	"@edit_synth_note@": "Edit Synthetic Note",
	"@new_synth_note@": "Synthetic Note",
	"@Edit_External_Link@": "Edit External Link",
	"@Insert_Image@": "Insert Image",
	"@Insert_Media@": "Insert Media",
	"@Select@": "Select",
	"@Upload@": "Upload",
	"@Select_file@": "Select file",
	"@Select_folder@": "Select folder",
	"@Upload_file@": "File",
	"@Filter@": "Filter",
	"@Loading...@": "Loading...",
	"@New_Revision@": "New Revision",
	"@edit_scope@": "Scope",
	"@edit_lemma@": "Lemma",
	"@edit_link@": "Link",
	"@edit_title@": "Title",
	"@edit_text@": "Text",
	"@edit_caption@": "Caption",
	"@edit_comment@": "Comment",
	"@edit_abbrev@": "Abbreviation",
	"@edit_zotero_id@": "Zotero ID",
	"@edit_parallel@": "Parallel?",
	"@Cut@": "Cut",
	"@Copy@": "Copy",
	"@Paste@": "Paste",
	"homedir": "Home",
	"@URL@": "URL",
	"editorial.info": {
		"revision.and.content.id": " %s (%s rev. %s)",
		"rev.n.and.author": "rev. %s (%s) by %s",
		"id.and.author": "%s (%s rev. %s) by %s"
	},
	"@login@": "sign in",
	"@Login@": "Sign In",
	"@invalid_login@": "Invalid name or password",
	"@logout@": "sign out",
	"@password@": "Password",
	"session": {
		"about.to.expire": "Your session is about to expire. Please press “Continue” to remain connected."
	},
	"continue": "Continue",
	"admin": {
		"menu": "Admin",
		"users": "Administer Users",
		"change.password": "Change Password",
		"permissions": "Permissions",
		"teams": "Administer Teams",
		"cache": "Cache"
	},
	"pericopes": {
		"total": "%s pericopes"
	},
	"pericope": {
		"new": "New Pericope"
	},
	"users": {
		"type.name.email.or.id": "Type a name, or email, or ID",
		"total": "%s users",
		"all": "All Users",
		"admins": "Administrators",
		"contributors": "Contributors",
		"scribes": "Scribes"
	},
	"user": {
		"new": "New User",
		"edit": "Edit %s",
		"verify.delete": "Delete this user?",
		"name": "User Name",
		"firstname": "First Name",
		"lastname": "Last Name",
		"email": "Email",
		"roles": "Roles",
		"lang": "Language",
		"is.active": "Active?",
		"is.approved": "Approved?",
		"is.deleted": "Deleted?",
		"is.admin": "Administrator?",
		"is.contributor": "Contributor?",
		"is.scribe": "Scribe?",
		"change.password": "Change password",
		"password.again": "Enter password again",
		"created": "User created.",
		"saved": "User saved.",
		"permissions": {
			"heading": "Permissions",
			"saved": "Permissions saved."
		},
		"error": {
			"passwords.do.not.match": "The passwords do not match.",
			"new.users.need.password": "New users must have a password.",
			"email.must.be.unique": "This email address is already registered.",
			"user.needs.email": "Please enter an email address."
		}
	},
	"teams": {
		"type.name.or.id": "Type a name or ID",
		"total": "%s teams"
	},
	"team": {
		"new": "New team",
		"edit": "Edit team “%s”",
		"verify.delete": "Delete this team?",
		"name": "Team name",
		"books": "Books",
		"members": "Members",
		"leaders": "Leaders",
		"members.and.leaders": "Team Members and Leaders",
		"available.users": "Available Users",
		"member.permissions": "Team Member Permissions",
		"created": "Team created.",
		"saved": "Team saved.",
		"members.saved": "Members saved."
	},
	"books": {
		"assigned": "Books Assigned",
		"available": "Books Available"
	},
	"@Write@": "Write",
	"@None@": "None",
	"@all_types@": "All Types",
	"@not_approved_users_table_header@": "There are %s users waiting to be approved.",
	"@approve_user_sure@": "Approve this user?",
	"@admin@": "Administrator",
	"@Contributor@": "Contributor",
	"@Scribe@": "Scribe",
	"@user@": "User",
	"@team@": "Team",
	"@please_enter@": "Please enter.",
	"@please_enter_valid_email@": "Please enter a valid email address.",
	"@register@": "Register",
	"@forgot_password@": "Forgot Password",
	"@password_again@": "Password again",
	"@verify_password@": "Verify password",
	"@success_password_changed@": "Password changed.",
	"@register_complete@": "Registration complete. You will receive an email notification when an administrator has approved your account.",
	"@search@": "Search",
	"@manage_team_users@": "Manage Users of Team “%s”",
	"@add_users_to_team@": "Add Users To Team",
	"@select_team_leader@": "Select Team Leader",
	"@Caches@": "Caches",
	"@empty@": "empty",
	"@Cache_emptied@": "Cache emptied",
	"message.join": "%s: %s",
	"form": {
		"required": "Required"
	},
	"@Error@": "Error",
	"@edit@": "edit",
	"@Edit@": "Edit",
	"@delete@": "delete",
	"@close@": "close",
	"@edit_save@": "Save",
	"@change@": "change",
	"@cancel@": "Cancel",
	"@yes@": "yes",
	"@no@": "no",
	"@Previous@": "Previous",
	"@Next@": "Next &gt;",
	"@first@": "first",
	"@last@": "last",
	"opens.in.new.tab": "opens in a new tab",
	"Filter.verb": "Filter",
	"@Scope@": "Scope",
	"@range@": "%s–%s",
	"@rows_total@": "%s rows",
	"@Download@": "Download",
	"@PaperFormat@": "Paper Format",
	"@FontSize@": "Font Size",
	"@PaperLetter@": "Letter",
	"all.traditions": "All Textual Traditions",
	"@verse_1untranslated@": "Some or all of the verses displayed above have not yet been translated for this project. In such cases, default text in the public domain has been used instead.",
	"@verse_2untranslated@": "Verses which appear like this are from the King James / Authorized Version.",
	"editorial": {
		"pericopes": "Define Pericopes",
		"activity": "Activity"
	},
	"only.errors": "Only errors",
	"@book@": "Book",
	"@select_book@": "Select Book",
	"@select_user@": "Select User",
	"@save_changes@": "Save Changes",
	"@please_select@": "Please select",
	"@home@": "home",
	"@send@": "Send",
	"@forgot_password_text@": "Please type your email here and your password will be sent to you.",
	"@email_not_exists@": "Email is not registered",
	"@forgot_password_letter_send@": "Letter with new password has been sent",
	"@issues@": "Issues",
	"@all_authors@": "All authors",
	"@author@": "Author",
	"@assigned_to@": "Assigned to",
	"@status@": "Status",
	"@Type_Status_Assigned_to@": "Type: %s, Status: %s, Assigned to: %s",
	"@Created@": "Created: %s:",
	"@editorial_info@": "Editorial information",
	"@Last_Modified@": "Last modified: %s",
	"@approve@": "approve",
	"@Approve@": "Approve",
	"@publish@": "publish",
	"@Publish@": "Publish",
	"@history@": "history",
	"@History@": "History",
	"@Full_History@": "Full History",
	"@Compare_Revisions@": "Compare Revisions",
	"@Show_editorial_information@": "Show editorial information",
	"@published@": "Published",
	"@PUBLISHED@": "PUBLISHED",
	"@approved@": "Approved",
	"@APPROVED@": "APPROVED",
	"@awaiting_approval@": "Awaiting Approval",
	"@AWAITING_APPROVAL@": "AWAITING APPROVAL",
	"@archived@": "Archived",
	"@Audience@": "Audience",
	"@Change_Audience@": "Change",
	"@public@": "Public",
	"@general@": "Donors",
	"@scholarly@": "Contributors",
	"@no_audience@": "no audience",
	"@ARCHIVED@": "ARCHIVED",
	"@PUBLIC@": "PUBLIC",
	"@GENERAL@": "DONORS",
	"@SCHOLARLY@": "CONTRIBUTORS",
	"@NO_AUDIENCE@": "NO AUDIENCE",
	"@show_all@": "Show All",
	"@type@": "Type",
	"@title@": "Title",
	"@date@": "Date",
	"@id@": "ID",
	"@issue_count@": "%s issues",
	"@note_count@": "%s notes",
	"@you_are_not_approved@": "You are not approved!",
	"@you_are_not_activated@": "You are not activated!",
	"@registered@": "Registered",
	"@note@": "note",
	"@Note@": "Note",
	"@rev@": "rev. %d",
	"@by@": "by %s",
	"@Marg_ref_and_id@": "Marginal Reference %d",
	"@Marg_ref_rev_and_id@": "Marginal Reference %d rev. %d (%d)",
	"@Reference_and_id@": "Bibliographic Reference %d",
	"@Reference_rev_and_id@": "Bibliographic Reference %d rev. %d (%d)",
	"@Note_and_id@": "Note %d",
	"@Note_rev_and_id@": "Note %d rev. %d (%d)",
	"@Synth_note_and_id@": "Synthetic Note %d",
	"@Synth_note_rev_and_id@": "Synthetic Note %d rev. %d (%d)",
	"@Verse_and_id@": "%s %d",
	"@Verse_rev_and_id@": "%s %d rev. %d (%d)",
	"@Submit@": "Submit",
	"@Save_as_Draft@": "Save as Draft",
	"@rev_and_id@": "%d rev. %d (%d)",
	"@revision@": "Revision",
	"@draft@": "Draft",
	"@DRAFT@": "DRAFT",
	"@approved_by@": "Approved by %s on %s",
	"@disapprove@": "Disapprove",
	"@Original_Active_Revision@": "Original Active Revision: %s",
	"@Original_Revision@": "Original Revision: %s",
	"@Active_Revision@": "Active Revision: %s",
	"@dismiss@": "Dismiss",
	"@other_revisions_text@": "This note also has other unapproved revisions.",
	"@count_issues_associated@": "There are %s issues associated with this change.",
	"@text@": "Text",
	"@assigned_by@": "Assigned By",
	"@assign_to@": "Assign To",
	"@New_Issue@": "New Issue",
	"@New_Comment@": "Add New Comment",
	"@new@": "New",
	"@feedback@": "Feedback",
	"@closed@": "Closed",
	"@open@": "Open",
	"@acknowledged@": "Acknowledged",
	"@message@": "Message",
	"@issue_title@": "Issue Title",
	"@ref@": "Ref",
	"@created@": "Created",
	"@Rev@": "Rev",
	"@delete_issue_confirm@": "Are you sure you want to delete this issue?",
	"@Choose_Synth_Note@": "Choose a Synthetic Note",
	"@Choose_Bib_Ref@": "Choose a Bibliographic Reference",
	"@Link_Text@": "Link Text",
	"@Choose@": "Choose",
	"@selection@": "Selection",
	"synthetic.note": {
		"not.found": {
			"title": "Synthetic note not found",
			"text": "<p>The synthetic note was not found. This probably means that the note has not yet been published.</p>"
		}
	},
	"bibliographic.reference": {
		"not.found": {
			"title": "Bibliographic reference not found",
			"text": "<p>The bibliographic reference was not found. This probably means that the it has not yet been published.</p>"
		}
	},
	"reference": {
		"not.found": "Reference not found"
	},
	"@error.verify@": "An error has occurred: %s. %s Please verify what you have typed.",
	"@error.marg_ref_not_saved@": "The marginal reference has not been saved.",
	"@error.bib_ref_not_saved@": "The bibliographic reference has not been saved.",
	"@error.note_not_saved@": "The note has not been saved.",
	"@error.synth_note_not_saved@": "The synthetic note has not been saved.",
	"@error.verse_not_saved@": "The verse has not been saved.",
	"Failed to parse": "Failed to parse",
	"No context for parsing": "No context for parsing",
	"Unknown book": "Unknown book",
	"Unknown delimiter": "Unknown delimiter",
	"Invalid chapter": "Invalid chapter",
	"Verse fragment or following verses after chapter": "Verse fragment or following verses after chapter",
	"No chapter or verse at the end of a verse range": "No chapter or verse at the end of a verse range",
	"Found \"f\" or \"ff\" at the end of a verse range": "Found \"f\" or \"ff\" at the end of a verse range",
	"Range followed by another range": "Range followed by another range"
};